import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { ActivationMessages } from "@/messages/platforms/talk2PayConnection/activationMessages";

import { FormFields } from "./activationForm";

interface Props {
  messages: ActivationMessages;
}

export function Activation({ messages }: Props) {
  return (
    <MDBox>
      <MDBox>
        <MDTypography variant="h5"> {messages.formTitle}</MDTypography>
      </MDBox>

      <FormFields messages={messages} />
    </MDBox>
  );
}
